import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DataTablesService } from '../../../../core';
import { PessoaContato } from '../pessoa-contato';
import { isContatoSituacaoAtivo, isContatoSituacaoInativo } from '../situacao';
import { isContatoTipoPrincipal } from '../tipo';

@Component({
    selector: 'sgt-pessoa-contato-table',
    templateUrl: './pessoa-contato-table.component.html',
    styleUrls: ['./pessoa-contato-table.component.less']
})
export class PessoaContatoTableComponent implements OnInit {
    @Input() idTable = 'tablePessoaContatos';
    dataTable: any;

    @Input() canEdit = true;
    @Input() entities: PessoaContato[];
    @Output() edit = new EventEmitter<number>();
    @Output() delete = new EventEmitter<number>();
    @Output() ativar = new EventEmitter<number>();
    @Output() inativar = new EventEmitter<number>();

    constructor(private dataTablesService: DataTablesService) { }

    ngOnInit() {
        this.showTable();
    }

    private showTable() {
        this.dataTablesService.showTable(`#${this.idTable}`, this.dataTable, {
            orderFixed: [[ 1, 'desc' ], [ 2, 'asc' ]],
            order: [[3, 'asc'], [4, 'asc']],
            columnDefs: [
                {visible:  false, targets: [1, 2]}
            ],
            info: false,
            paging: false,
            searching: false
        })
        .then(dataTable => this.dataTable = dataTable);
    }

    refresh() {
        this.dataTable?.draw(false);
    }

    /** Verifica se pode ativar o contato */
    canAtivar(entity: PessoaContato): boolean {
        if (!entity || !this.canEdit) {
            return false;
        }
        // Somente se o contato estiver inativo
        return isContatoSituacaoInativo(entity.situacao);
    }


    /** Verifica se pode inativar o contato */
    canInativar(entity: PessoaContato): boolean {
        if (!entity || !this.canEdit) {
            return false;
        }
        // Não permite inativar o contato principal
        if (isContatoTipoPrincipal(entity.tipo)) {
            return false;
        }
        // Somente se o contato estiver ativo
        return isContatoSituacaoAtivo(entity.situacao);
    }

    /** Verifica se permite excluir o contato */
    canDelete(entity: PessoaContato) {
        if (!entity || !this.canEdit) {
            return false;
        }
        // Somente permite excluir o contato que ainda não tiver ID, ou seja, que ainda não foi salvo no banco de dados
        return !entity.id;
    }
}
